import React, {useEffect} from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import UserForm from "./_form";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";

// labels
import {
    LIST,
    NO_DATA_FOUND,
} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import {roleService, userService} from "../../../jwt/_services";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import RoleForm from "./_form";
import RoleFilters from "./_filters";

// services


const RoleList = props => {
    const { path } = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    // asignar los valores por default del filtro
    useEffect( () => {

        props.setFilter(path, {} )
    }, [  ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if (!filter) return;

        genericIndexedActions.search(path, roleService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({path, remove : genericIndexedActions.delete, fbDataBaseId: null , data : data, service: roleService } );
    };

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(RoleForm, { path, data, closeOnEscape:false, closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(RoleForm, { path })
    }

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'authority',
        text: 'Rol',
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <RoleFilters path={path} />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(RoleList)